import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import crud from "./crud.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import snackbar from "./snackbar.module";
import forgotPassword from "@/core/store/forgotPassword.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    crud,
    htmlClass,
    config,
    breadcrumbs,
    snackbar,
    forgotPassword
  }
});
